module.exports = __webpack_public_path__ + "static/media/aiDesignerHsbcTemplate1.a3798a22.jpg";